import {TweenMax, Power1, Power3, Expo, Linear} from 'gsap';
import AbstractView = require("./abstract/AbstractView");

class KVView extends AbstractView {


    private nameCon: JQuery;
    private coverCon: JQuery;

    constructor(id: number = -1, selector: JQuery) {
        super(id, selector);
    }


    resize(): void {
        if (this.coverCon && this.nameCon) {
            let fixH: number = (this.coverCon.height() > window.innerHeight) ? window.innerHeight - 40 : this.coverCon.height() - 40;
            this.nameCon.height(fixH);
        }
    }

    private productL: JQuery;
    private productR: JQuery;

    init(): void {
        this.coverCon = this.getChildBySelector(".coverCon");
        this.nameCon = this.getChildBySelector(".nameCon");

        this.productL = this.coverCon.find(".product-l");
        this.productR = this.coverCon.find(".product-r");

        TweenMax.fromTo(this.productL, 1, {
            alpha: 0,
            x: -100
        }, {
            delay: 1,
            alpha: 1,
            x: 0,
            ease: Power3.easeOut
        });
        TweenMax.fromTo(this.productR, 1, {
            alpha: 0,
            x: 100
        }, {
            delay: 1,
            alpha: 1,
            x: 0,
            ease: Power3.easeOut
        });
    }


}

export = KVView;